// extracted by mini-css-extract-plugin
var _1 = "gJrhs";
var _2 = "xBzSW";
var _3 = "TQ1Hs";
var _4 = "wY7fi";
var _5 = "iIvs1";
export { _1 as "label", _2 as "label-value", _3 as "label-value--bold", _4 as "payment-breakdown", _5 as "title" }
